import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';

export default class FullscreenImageSwipeView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rendered: false,
    };
  }

  renderChild() {
    if (this.state.rendered) return;

    this.setState({ rendered: true });
  }

  render() {
    if (!this.state.rendered) {
      return null;
    } else {
      return this.props.children;
    }
  }
}
